export default {
  install(app) {
    app.config.globalProperties.$settings = {
      fip: {
        url:
          process.env.NODE_ENV === 'development'
            ? 'https://staging59.foundationip.com/foundationIP/navigation'
            : 'https://fip2.foundationip.com/foundationIP/navigation'
      }
    };
  }
};
